/* =========================================================
   Custom header — behaviour for <vh-header> only
   ========================================================= */
(function () {
  'use strict';
  if (!window.customElements || customElements.get('vh-header')) return;

  var DESKTOP = '(min-width: 990px)';
  var WL_KEY = 'wl_wishlist';

  function wishCount() {
    try { return (JSON.parse(localStorage.getItem(WL_KEY)) || []).length; } catch (e) { return 0; }
  }

  class VhHeader extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var self = this;
      // Wait until the header's contents exist
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { self.init(); }, { once: true });
      } else {
        this.init();
      }
    }

    init() {
      if (this._inited || !this.isConnected) return;
      this._inited = true;
      var self = this;
      this.section = this.closest('.shopify-section') || this.parentElement;
      this.bar = this.querySelector('.vh__bar');
      this.drawer = this.querySelector('[data-vh-drawer]');
      this.burger = this.querySelector('[data-vh-burger]');
      this.mq = window.matchMedia(DESKTOP);
      this.lastY = window.pageYOffset;

      this.place();
      this.updateWish();

      this.onMq = function () {
        self.closeDrawer();
        self.closeSearch();
        self.place();
      };
      if (this.mq.addEventListener) this.mq.addEventListener('change', this.onMq);
      else if (this.mq.addListener) this.mq.addListener(this.onMq);

      this.onScroll = this.throttle(function () { self.scrollState(); });
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.scrollState();

      this.onKey = function (e) {
        if (e.key !== 'Escape') return;
        self.closeDrawer();
        self.closeSearch();
        self.closeDropdowns();
      };
      document.addEventListener('keydown', this.onKey);

      this.onDocClick = function (e) {
        if (!self.contains(e.target)) {
          self.closeSearch();
          self.closeDropdowns();
        }
        // Wishlist hearts elsewhere on the page may change the count
        setTimeout(function () { self.updateWish(); }, 60);
      };
      document.addEventListener('click', this.onDocClick);

      this.onStorage = function (e) { if (!e || e.key === WL_KEY) self.updateWish(); };
      window.addEventListener('storage', this.onStorage);

      this.addEventListener('click', function (e) { self.onClick(e); });
      this.addEventListener('focusin', function (e) {
        if (e.target.matches('.vh-search__input')) self.setSearchTop(e.target);
      });
      this.addEventListener('input', function (e) {
        if (e.target.matches('.vh-search__input')) self.setSearchTop(e.target);
      });
      this.addEventListener('change', function (e) {
        if (e.target.matches('[data-vh-country]') && e.target.form) e.target.form.submit();
      });

      this.bindCart();
      this.bindPeek();
    }

    disconnectedCallback() {
      if (!this._inited) return;
      window.removeEventListener('scroll', this.onScroll);
      document.removeEventListener('keydown', this.onKey);
      document.removeEventListener('click', this.onDocClick);
      window.removeEventListener('storage', this.onStorage);
      if (this.mq) {
        if (this.mq.removeEventListener) this.mq.removeEventListener('change', this.onMq);
        else if (this.mq.removeListener) this.mq.removeListener(this.onMq);
      }
      if (this.unsubscribeCart) this.unsubscribeCart();
      if (this.onPeekMove) document.removeEventListener('mousemove', this.onPeekMove);
      document.documentElement.classList.remove('vh-lock');
    }

    throttle(fn) {
      var queued = false;
      return function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; fn(); });
      };
    }

    /* ---------- place items into their areas ---------- */
    place() {
      var desktop = this.mq.matches;
      var items = Array.prototype.slice.call(this.querySelectorAll('[data-vh-item]'));
      items.sort(function (a, b) {
        return (parseInt(desktop ? a.dataset.od : a.dataset.om, 10) || 0) - (parseInt(desktop ? b.dataset.od : b.dataset.om, 10) || 0);
      });
      var self = this;
      items.forEach(function (el) {
        var zone = desktop ? el.dataset.d : el.dataset.m;
        var target = self.querySelector('[data-vh-zone="' + zone + '"]') || self.querySelector('[data-vh-zone="none"]');
        if (target) target.appendChild(el);
      });
      this.classList.add('is-placed');
    }

    /* ---------- scroll ---------- */
    scrollState() {
      var y = window.pageYOffset;
      this.classList.toggle('is-scrolled', y > 10);
      if (this.classList.contains('vh--autohide')) {
        var barH = this.bar ? this.bar.offsetHeight : 0;
        var drawerOpen = this.classList.contains('is-drawer-open');
        if (y <= barH) {
          this.classList.remove('is-hidden');
          this.classList.remove('is-peek');
        } else if (this.searching()) {
          this.classList.remove('is-hidden');
        } else if (this.classList.contains('vh--sticky-hover')) {
          if (!drawerOpen) this.classList.add('is-hidden');
        } else if (y > this.lastY && y > barH + 40 && !drawerOpen) {
          this.classList.add('is-hidden');
        } else if (y < this.lastY) {
          this.classList.remove('is-hidden');
        }
        this.syncPointer();
      }
      this.lastY = y;
      if (this.classList.contains('is-drawer-open')) this.setDrawerTop();
    }

    syncPointer() {
      if (!this.section || this.section === document.body) return;
      var blocked = this.classList.contains('is-hidden') && !this.classList.contains('is-peek') && !this.classList.contains('is-drawer-open');
      this.section.style.pointerEvents = blocked ? 'none' : '';
    }

    bindPeek() {
      if (!this.classList.contains('vh--sticky-hover')) return;
      var self = this;
      var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
      this.onPeekMove = function (e) {
        if (!canHover.matches || !self.classList.contains('is-hidden')) return;
        if (e.clientY <= 12 && !self.classList.contains('is-peek')) {
          self.classList.add('is-peek');
          self.syncPointer();
        }
      };
      this.onPeekLeave = function (e) {
        if (!self.classList.contains('is-peek')) return;
        if (e.relatedTarget && self.contains(e.relatedTarget)) return;
        self.classList.remove('is-peek');
        self.closeDropdowns();
        self.closeSearch();
        self.syncPointer();
      };
      document.addEventListener('mousemove', this.onPeekMove, { passive: true });
      this.addEventListener('mouseleave', this.onPeekLeave);
    }

    /* ---------- clicks ---------- */
    onClick(e) {
      var t = e.target;

      if (t.closest('[data-vh-burger]')) {
        e.preventDefault();
        if (this.classList.contains('is-drawer-open')) this.closeDrawer();
        else this.openDrawer();
        return;
      }

      var sub = t.closest('[data-vh-open-sub]');
      if (sub) {
        e.preventDefault();
        this.openSub(sub.getAttribute('data-vh-open-sub'));
        return;
      }

      if (t.closest('[data-vh-back]')) {
        e.preventDefault();
        this.closeSubs();
        return;
      }

      if (t.closest('[data-vh-search-toggle]')) {
        e.preventDefault();
        if (this.classList.contains('is-search-open')) this.closeSearch();
        else this.openSearch();
        return;
      }

      // Touch screens at desktop width: first tap opens the dropdown
      var link = t.closest('.vh-nav__item--dd > .vh-nav__link');
      if (link && this.mq.matches && window.matchMedia('(hover: none)').matches) {
        var item = link.parentElement;
        if (!item.classList.contains('is-open')) {
          e.preventDefault();
          this.closeDropdowns();
          item.classList.add('is-open');
          link.setAttribute('aria-expanded', 'true');
        }
      }
    }

    closeDropdowns() {
      this.querySelectorAll('.vh-nav__item.is-open').forEach(function (item) {
        item.classList.remove('is-open');
        var l = item.querySelector('.vh-nav__link');
        if (l) l.setAttribute('aria-expanded', 'false');
      });
    }

    /* ---------- drawer ---------- */
    setDrawerTop() {
      if (!this.bar) return;
      var rect = this.bar.getBoundingClientRect();
      this.style.setProperty('--vh-drawer-top', Math.max(0, Math.round(rect.bottom)) + 'px');
    }

    openDrawer() {
      if (!this.drawer) return;
      this.closeSearch();
      this.classList.add('is-drawer-open');
      this.drawer.hidden = false;
      this.setDrawerTop();
      if (this.burger) this.burger.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('vh-lock');
      var self = this;
      requestAnimationFrame(function () { self.setDrawerTop(); });
    }

    closeDrawer() {
      if (!this.drawer || !this.classList.contains('is-drawer-open')) return;
      this.classList.remove('is-drawer-open');
      if (this.burger) this.burger.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('vh-lock');
      var d = this.drawer;
      var self = this;
      setTimeout(function () {
        if (!self.classList.contains('is-drawer-open')) {
          d.hidden = true;
          self.closeSubs(true);
        }
      }, 230);
    }

    openSub(id) {
      var panel = this.querySelector('[data-vh-panel="' + id + '"]');
      if (!panel) return;
      panel.hidden = false;
      requestAnimationFrame(function () { panel.classList.add('is-active'); });
      var back = panel.querySelector('[data-vh-back]');
      if (back) back.focus({ preventScroll: true });
    }

    closeSubs(instant) {
      this.querySelectorAll('.vh-drawer__sub').forEach(function (p) {
        p.classList.remove('is-active');
        if (instant) p.hidden = true;
        else setTimeout(function () { if (!p.classList.contains('is-active')) p.hidden = true; }, 290);
      });
    }

    /* ---------- search ---------- */
    openSearch() {
      this.classList.add('is-search-open');
      var rect = this.bar ? this.bar.getBoundingClientRect() : { bottom: 100 };
      this.style.setProperty('--vh-search-top', Math.round(rect.bottom + 12) + 'px');
      var input = this.querySelector('.vh-zone .vh-search__input');
      this.querySelectorAll('[data-vh-search-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      if (input) setTimeout(function () { input.focus(); }, 30);
    }

    closeSearch() {
      if (!this.classList.contains('is-search-open')) return;
      this.classList.remove('is-search-open');
      this.querySelectorAll('[data-vh-search-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    }

    setSearchTop(input) {
      var form = input.form || input;
      var r = form.getBoundingClientRect();
      this.style.setProperty('--vh-ps-top', Math.round(r.bottom + 24) + 'px');
    }

    searching() {
      var a = document.activeElement;
      return !!(a && this.contains(a) && a.matches && a.matches('.vh-search__input'));
    }

    /* ---------- wishlist count ---------- */
    updateWish() {
      var n = wishCount();
      this.querySelectorAll('[data-vh-wish-count]').forEach(function (el) {
        if (el.textContent !== String(n)) el.textContent = String(n);
        el.hidden = n === 0;
      });
    }

    /* ---------- cart ---------- */
    bindCart() {
      var self = this;
      var cartLink = this.querySelector('[data-vh-cart]');
      if (cartLink && this.getAttribute('data-open-drawer') === 'true') {
        cartLink.addEventListener('click', function (e) {
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') {
            e.preventDefault();
            self.closeDrawer();
            drawer.open(cartLink);
          }
        });
      }

      var refresh = function () { self.refreshCartCount(); };
      // Trade / Dawn themes announce cart changes through their pub/sub helper
      try {
        /* global subscribe, PUB_SUB_EVENTS */
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          this.unsubscribeCart = subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
        }
      } catch (e) { /* theme without pub/sub */ }
      ['cart:updated', 'cart:refresh', 'cart:change', 'ajaxProduct:added'].forEach(function (ev) {
        document.addEventListener(ev, refresh);
      });
    }

    refreshCartCount() {
      var self = this;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          self.querySelectorAll('[data-vh-cart-count]').forEach(function (el) {
            el.textContent = String(cart.item_count);
            el.hidden = cart.item_count === 0;
          });
        })
        .catch(function () {});
    }
  }

  customElements.define('vh-header', VhHeader);
})();